import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import React from 'react';


interface RoutesConfigProps {
    enabled: boolean;
    onChange: (checked: boolean) => void;
}

const RoutesConfig: React.FC<RoutesConfigProps> = ({enabled, onChange}) => {

    const handleRouteEnabled = () => {
        onChange(!enabled);
    };

    return (
        <div className="p-16 pl-0 rounded-8 bg-white flex items-start justify-between">
            <div className="space-y-8 w-80p">
                <p className="body-1 bold text-darwin-neutral-1000">
                    Enable Route Field in Medication Details
                </p>
                <p className="flex body-3 text-darwin-neutral-700">
                    Display the administration route (e.g., oral, IV, topical) as part of each
                    medication entry to enhance clarity and accuracy.
                </p>
            </div>
            <div className="flex f-full flex-col justify-between align-end">
                <div onClick={handleRouteEnabled} className="darwin-switch primary">
                    <input type="checkbox" checked={enabled} />
                    <span className="slider" />
                </div>
            </div>
        </div>
    );
};

export default RoutesConfig;
